module.exports = __webpack_public_path__ + "static/media/asada-shino-win.7cc2a47c.png";